import React from 'react'

import Button, {
  ButtonTypes,
  ButtonVariants,
} from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import Map from '~/components/atoms/Map/Map'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { useMediaQuery } from '~/services/useMediaQuery'
import bp from '~/styles/breakpoints/breakpoints'

import type { PartnerCardProps } from '../PartnerCard/PartnerCard'

import styles from './MapWidget.module.css'

interface MapWidgetProps {
  partners: PartnerCardProps[]
  listViewHandler: () => void
  mapViewHandler: () => void
}

const MapWidget: React.FC<MapWidgetProps> = ({
  partners,
  listViewHandler,
  mapViewHandler,
}) => {
  const isMobile = useMediaQuery(`(max-width: ${bp.bpMedium})`)

  return (
    <div className={styles.base}>
      <div className={styles.header}>
        <Container>
          <Text size={TextSizes.primaryTitleLrg} className={styles.title}>
            Search by location
          </Text>
          <Text size={TextSizes.bodyMed} className={styles.summary}>
            Discover services to facilitate art collection and management in
            your area.
          </Text>

          <div className={styles.buttonContainer}>
            <Button
              variant={ButtonVariants.capsUnderlineSml}
              button={{ onClick: mapViewHandler, type: ButtonTypes.button }}
            >
              View on map
            </Button>
            <Button
              variant={ButtonVariants.capsUnderlineSml}
              button={{ onClick: listViewHandler, type: ButtonTypes.button }}
            >
              View as list
            </Button>
          </div>
        </Container>
      </div>

      <Map
        locations={partners}
        clickThroughToUrl
        height={isMobile ? 400 : 580}
      />
    </div>
  )
}

export default MapWidget
